import { useTranslation } from 'react-i18next'
import { useReactFlow } from '@xyflow/react'

import { useStateMachineEditorContext } from '../../context/StateMachineEditorContext'

import { Button, Divider, Flex } from '@percent/lemonade'

export function CanvasToolbar() {
  const { t } = useTranslation()
  const { zoomIn, zoomOut, fitView } = useReactFlow()
  const { handleSave, handleUndo, handleRedo, canUndo, canRedo, hasUnsavedChanges, isUpdating } =
    useStateMachineEditorContext()

  return (
    <Flex
      align="center"
      gap="xs"
      p={8}
      mb={8}
      style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 }}
      data-testid="canvas-toolbar"
    >
      <Button variant="secondary" size="small" onClick={() => zoomIn()} data-testid="toolbar-zoom-in">
        +
      </Button>
      <Button variant="secondary" size="small" onClick={() => zoomOut()} data-testid="toolbar-zoom-out">
        -
      </Button>
      <Button variant="secondary" size="small" onClick={() => fitView()} data-testid="toolbar-fit-view">
        {t('stateMachine.toolbar.fitView')}
      </Button>

      <Divider orientation="vertical" />

      <Button variant="secondary" size="small" onClick={handleUndo} disabled={!canUndo} data-testid="toolbar-undo">
        {t('stateMachine.toolbar.undo')}
      </Button>
      <Button variant="secondary" size="small" onClick={handleRedo} disabled={!canRedo} data-testid="toolbar-redo">
        {t('stateMachine.toolbar.redo')}
      </Button>

      <Flex flex={1} />

      <Button
        variant="primary"
        size="small"
        onClick={handleSave}
        disabled={!hasUnsavedChanges || isUpdating}
        data-testid="toolbar-save"
      >
        {isUpdating ? t('stateMachine.toolbar.saving') : t('stateMachine.toolbar.save')}
      </Button>
    </Flex>
  )
}
